var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"week-row",style:({'min-height':_vm.customHeight}),on:{"click":_vm.showWeekNumber}},_vm._l((_vm.week),function(day,index){return _c('day',{key:index,attrs:{"issmall":_vm.issmall,"dayselect":_vm.dayclicked,"showable":day.isShowable,"day":day}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }